// Core React Imports
import React from "react";

// Local Imports
import { DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import WidgetInputBase from "../widget-input-base/WidgetInputBase";
import WidgetRequiredLabel from "../../shared_widgets/widget-required-label/WidgetRequiredLabel";

// CSS/Stylesheets
import "./WidgetInput.css";

const WidgetInput = ({
  label,
  value,
  onChange,
  heightProp = "4.4rem",
  widthProp = "100%",
  backgoundColortProp = "#e9eaee",
  titleColorProp,
  fontSizeTitle = "1.2rem",
  paddingProp = "0rem 1rem",
  textColorProp,
  fontFamilyInputProp,
  disabled = false,
  isRequiredUI = false,
}) => {
  return (
    <div className="widget-input-frame" style={{ height: heightProp, width: widthProp }}>
      <div className="widget-input-frame-2" style={{ backgroundColor: backgoundColortProp, padding: paddingProp }}>
        <DivColumn className="widget-input-frame-3">
          <WidgetRequiredLabel isRequired={isRequiredUI}>
            <ParagraphText className="widget-input-text" style={{ fontSize: fontSizeTitle, color: titleColorProp }}>
              {label}
            </ParagraphText>
          </WidgetRequiredLabel>
          <WidgetInputBase value={value} onChange={onChange} style={{ color: textColorProp, fontFamily: fontFamilyInputProp }} disabled={disabled} />
        </DivColumn>
      </div>
    </div>
  );
};

export default WidgetInput;
